import { type RefObject, useEffect, useState } from 'react';

import { LandingButton } from './LandingButton';
import * as styles from './StickyClaimBar.css';

interface StickyClaimBarProps {
  /** The hero's claim button; the bar shows once it has scrolled up past the viewport. */
  watchRef: RefObject<HTMLElement | null>;
  claimHref: string;
  ctaLabel: string;
  onClaimClick?: () => void;
}

export const StickyClaimBar = ({
  watchRef,
  claimHref,
  ctaLabel,
  onClaimClick,
}: StickyClaimBarProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const watched = watchRef.current;

    if (!watched || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0),
      { threshold: 0 },
    );
    observer.observe(watched);
    return () => observer.disconnect();
  }, [watchRef]);

  return (
    <div className={styles.bar} data-visible={visible} aria-hidden={!visible} inert={!visible}>
      <LandingButton href={claimHref} size="compact" block onClick={onClaimClick}>
        {ctaLabel}
      </LandingButton>
    </div>
  );
};
